export default (arr, num) => {
  var result = [];

  var count = arr.length;
  if (num > count) {
    num = count;
  }
  for (var i = 0; i < num; i++) {
    var index = ~~(Math.random() * count) + i;
    if (result.indexOf(arr[index]) !== -1) {
      continue;
    }
    result[i] = arr[index];
    arr[index] = arr[i];
    count--;
  }

  return result;
};
